import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper/fromDTO'
import { GET_AB_TEST_PARAMETERS_SCHEMA } from './api/query'
import { Data, Variables } from './api/types'

import type { Props, UseGetAbTestParametersSchema } from './types'
import type { AbTestParametersSchema } from 'features/ab-tests/types/abTestParametersSchema'

export const useGetAbTestParametersSchema = ({ domainId }: Props): UseGetAbTestParametersSchema => {
  const [schema, setSchema] = useState<AbTestParametersSchema>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { abTestParametersSchema } = data

      if (abTestParametersSchema) {
        setSchema(fromDTO(abTestParametersSchema))
      }
    },
    options: {
      enabled: Boolean(domainId),
    },
    query: GET_AB_TEST_PARAMETERS_SCHEMA,
    variables: { domainId: domainId! },
  })

  return { loading, schema }
}
